import {STATUS_TYPES} from '../../render/constants'
import {ImageLoader} from './image-loader'

class ImageViewer extends ImageLoader {
  constructor(shell, status) {
    super(status)

    this.onImageLoad = this.onImageLoad.bind(this)

    // 30 px on each side
    this.imagePadding = 60
    this.shell = shell
    this.status.set(STATUS_TYPES.loading)

    const url = this.shell.getAttribute('data-image')
    this.fetch(url, this.onImageLoad)
  }

  onImageLoad(image) {
    this.shell.appendChild(image)
    this.status.set(STATUS_TYPES.ready, {height: this.imageHeightAfterResize(image) + this.imagePadding})
  }

  documentWidth() {
    try {
      const renderShell = document.querySelector('.render-shell')
      /**
       * We use this over boundingClientRect because the original jquery implementation
       * was consistently returning 0. This was due to the .width method being called on
       * a hidden div. boundClientRect seems to be able to correctly resolve the true
       * width of the image, which led to the image being incorrectly scaled.
       */
      const shellStyles = window.getComputedStyle(renderShell)

      return parseInt(shellStyles.width)
    } catch (error) {
      window.debug('Failed to parse iframe document width')
    }
  }

  imageCssWidth(image) {
    try {
      return window.getComputedStyle(image).width
    } catch (error) {
      window.debug('Failed to parse image width', error.message)
    }
  }

  computeMaxWidth(image, fallback = 600) {
    const docWidth = this.documentWidth()
    const cssWidth = this.imageCssWidth(image)
    const parsedWidth = parseInt(cssWidth)

    window.debug(`imageHeightAfterResize: cssWidth:[${cssWidth}] parsedWidth:[${parsedWidth}]`)

    if (!cssWidth || isNaN(parsedWidth)) {
      return fallback
    }

    const minWidth = Math.min(docWidth, parsedWidth)

    if (cssWidth.slice(-1) === '%') {
      window.debug(`imageHeightAfterResize: Using a %: ${parsedWidth} of ${docWidth}`)
      if (!docWidth) {
        return fallback
      }
      return docWidth * (parsedWidth / 100.0)
    } else if (minWidth <= 0) {
      return fallback
    } else {
      return minWidth
    }
  }

  imageHeightAfterResize(img) {
    const {naturalHeight, naturalWidth} = img
    const maxWidth = this.computeMaxWidth(img)

    window.debug(`imageHeightAfterResize: maxWidth: ${maxWidth} vs width: ${naturalWidth} height: ${naturalHeight}`)

    if (img.height === 0) {
      img.height = naturalHeight
    }

    if (img.width === 0) {
      img.width = naturalWidth
    }

    // If we don't have a height, set the height to the maxWidth and hope for the best
    if (!naturalHeight) {
      img.height = maxWidth
    }

    // Return if the image is already resized
    if (naturalWidth <= maxWidth) {
      window.debug('Already resized, returning current height')
      return img.height || naturalHeight
    }

    const scalingFactor = maxWidth / naturalWidth
    window.debug(`Scaling height by ${scalingFactor} to ${naturalHeight} & ${scalingFactor}`)

    return naturalHeight * scalingFactor
  }
}

export default ImageViewer
